export const environment = {
  production: true,
  appVersion: require('../../package.json').version,
  mainApiUrl: 'https://mportal-api.azurewebsites.net/api/v1.0/',
  signalRUrl: 'https://memberportalfunctions.azurewebsites.net/api/negotiate',
  secureMailUrl: "https://secure-mail-api.azurewebsites.net/api/v1",
  defaultSlug: ''
};
